import { Stack } from "@mui/material";
import { Input, Text, TextArea, Title } from "@src/appV2/redesign/system/ui-components";
import { Controller, useFormContext } from "react-hook-form";

import { type CreateShiftVerificationRequestFormValues } from "../types";

interface CreateShiftVerificationRequestDetailsFormProps {
  isCalifornia: boolean;
}

export function CreateShiftVerificationRequestDetailsForm(
  props: CreateShiftVerificationRequestDetailsFormProps
) {
  const { isCalifornia } = props;

  const { control } = useFormContext<CreateShiftVerificationRequestFormValues>();

  return (
    <>
      {isCalifornia ? (
        <Stack spacing={4}>
          <Title semibold component="h6">
            Facility details
          </Title>
          <Stack spacing={2}>
            <Text variant="body2">Nursing services assignment</Text>
            <Controller
              name="nursingServicesAssignment"
              control={control}
              render={({ field }) => <Input {...field} placeholder="e.g. Acute Care" />}
            />
          </Stack>
          <Stack spacing={2}>
            <Text variant="body2">Station / Unit / Wing / Floor</Text>
            <Controller
              name="stationUnitWingFloor"
              control={control}
              render={({ field }) => <Input {...field} placeholder="e.g. 2nd Floor" />}
            />
          </Stack>
        </Stack>
      ) : null}

      <Stack spacing={4}>
        <Title semibold component="h6">
          Note to workplace (optional)
        </Title>

        <Controller
          name="reason"
          control={control}
          render={({ field }) => (
            <TextArea {...field} rows={3} placeholder="Explain what happened" />
          )}
        />
      </Stack>
    </>
  );
}
